<script lang="ts">
  import { goto } from '$app/navigation';

  import NotFoundVector from '$shared/images/not-found.jpg';
  import Button, { ButtonSizes, ButtonStyle } from '$shared/atoms/Button/Button.svelte';
  import Routes from '$provider/constants/Route';

  const onClickGoBack = (): void => {
    goto(Routes.Providers);
  };
</script>

<div class="page-404">
  <div class="image">
    <img src={NotFoundVector} alt="404 Page" />
  </div>
  <div class="container">
    <div class="title">404</div>
    <div class="sub-title">Looks like you're lost</div>
    <div class="desc">The page you are looking for is not available!</div>
    <div class="back-btn">
      <Button size={ButtonSizes.Large} style={ButtonStyle.Primary} on:click={onClickGoBack}
        >Go Back Home</Button
      >
    </div>
  </div>
</div>

<style>
  .image {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .image img {
    width: 80%;
  }
  .page-404 {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .title {
    font-size: 350px;
    line-height: 300px;
    font-weight: bold;
    color: var(--light-blue);
  }
  .sub-title {
    font-size: 40px;
    line-height: 1;
    margin-top: 40px;
    text-transform: uppercase;
    color: var(--grey-dark);
  }
  .desc {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
    margin-top: 16px;
  }
  .back-btn {
    margin-top: 48px;
  }
</style>
